export default __webpack_public_path__ + "img/ecrshJJw.00d9fc51.svg";